import { useMutation } from '@apollo/client';
import { DeleteInternalAuditResultsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteInternalAuditResultsTRPC } from './useDeleteInternalAuditResultsTRPC';

export const useDeleteInternalAuditResults = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteGraphQL, graphqlState] = useMutation(
    DeleteInternalAuditResultsDocument,
    {
      update: (cache) => {
        evictField(cache, 'obligation_internal_audit_result');
        evictField(cache, 'document_internal_audit_result');
        evictField(cache, 'risk_controlled_internal_audit_result');
        evictField(cache, 'risk_uncontrolled_internal_audit_result');
        evictField(cache, 'control_test_internal_audit_result');
        evictField(cache, 'impact_internal_audit_rating');
        evictField(cache, 'internal_audit_report');
        evictField(cache, 'obligation_internal_audit_result_aggregate');
        evictField(cache, 'document_internal_audit_result_aggregate');
        evictField(cache, 'risk_controlled_internal_audit_result_aggregate');
        evictField(cache, 'risk_uncontrolled_internal_audit_result_aggregate');
      },
    }
  );

  const trpcMutation = useDeleteInternalAuditResultsTRPC();

  const deleteInternalAuditResults = async (ids: string[]): Promise<void> => {
    if (trpcEnabled) {
      await trpcMutation.deleteInternalAuditResults(ids);

      return;
    }

    await deleteGraphQL({ variables: { Ids: ids } });
  };

  if (trpcEnabled) {
    return {
      deleteInternalAuditResults,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteInternalAuditResults,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
